// extracted by mini-css-extract-plugin
export default {"quick":"QuickDiscovery_quick__7DYda","cards":"QuickDiscovery_cards__C3Eq9","card":"QuickDiscovery_card__fyK4d","container":"QuickDiscovery_container__eiI0-"};